import { ITypedModel, IMediated, t_key, IncludedType } from 'core-ts-types';
import { IStateMemento } from '../core/state_memento';
import { ORM } from '../engine/orm';
import * as _4 from 'lodash';

export type IModelState<T> = { db: T };

export interface IModel<T> extends ITypedModel<T>, IStateMemento<IModelState<T>> {}

export class Model<T> implements IModel<T> {
  private __initialDB: T;

  constructor(protected _db: T) {
    this.__initialDB = _4.cloneDeep(this._db);

    _4.each(_4.keys(this._db), (property) => {
      Object.defineProperty(this, property, {
        get: function (this: Model<T>) {
          return this._db[property];
        }
      });
    });
  }

  write(model: Partial<T>): this {
    _4.merge(this._db, model);
    ORM.mark(this as IMediated);
    return this;
  }

  clear(): this {
    this._db = _4.cloneDeep(this.__initialDB);
    ORM.mark(this as IMediated);
    return this;
  }

  replace(model: Partial<T>): this {
    return this.clear().write(model);
  }

  read(): T {
    return this._db;
  }

  import(state: IModelState<T>): this {
    this._db = _4.merge({}, this.__initialDB, state.db);
    ORM.mark(this as IMediated);
    return this;
  }

  export(): IModelState<T> {
    return {
      db: this._db
    };
  }

  /**
   * create a model with defined properties
   * @param preferences properties belonging to the usersource
   */
  static build<T>(db: T): IncludedType<IModel<T>, T> {
    return new Model<T>(db) as IModel<T> as IncludedType<IModel<T>, T>;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-orm/src/types/model.ts